import { useEffect, useRef, useState } from 'react'
import { createBrowserAlertDelivery } from '../../lib/priceAlerts/browserDelivery.js'
export function useBrowserAlertDelivery(owner, notifications) {
  const delivery = useRef(null)
  const [state, setState] = useState({owner:null,desktop:false,sound:false,soundReady:false,message:''})
  useEffect(()=>{
    if (!owner) return
    const controller = createBrowserAlertDelivery({key:`erevis:alert-delivery:${import.meta.env.VITE_EREVIS_PRODUCT || 'personal'}:${owner}`,report:message=>setState(current=>({...current,message}))})
    delivery.current = controller
    setState({owner,...controller.settings,soundReady:false,message:''})
    return ()=>{controller.close();delivery.current=null}
  },[owner])
  useEffect(()=>{for(const notification of notifications) if (notification.ownerUserId === owner) delivery.current?.deliver(notification)},[notifications,owner])
  async function toggle(channel) {
    const controller = delivery.current
    if (!controller || state.owner !== owner) return
    setState(current=>({...current,message:''}))
    const settings = channel === 'desktop' ? controller.settings.desktop ? controller.save({desktop:false}) : await controller.enableDesktop()
      : controller.settings.sound && controller.soundReady ? controller.save({sound:false}) : await controller.enableSound()
    if (delivery.current === controller) setState(current=>({...current,...settings,soundReady:controller.soundReady}))
  }
  return {...(state.owner===owner?state:{desktop:false,sound:false,soundReady:false,message:''}),toggle}
}
